import React from "react";
import { RouteComponentProps } from "react-router";
import IIntegration from "../../models/IIntegration";
import Services from "../../services/Services";
import snackbarService from "../../services/ui-messaging/SnackbarService";
import WithLoadingSpinners from "../hoc/WithLoadingSpinner";
import IntegrationDetail from "./IntegrationDetail";
import { connect } from "react-redux";
import { IApplicationState } from "../../store";
import { selectAuth } from "../../store/auth/selectors";
import styled from "styled-components";
import { IntegrationContextProvider } from "./contexts/IntegrationContext";
import { selectCompany } from "../../store/context/selectors";
import ICompany from "../../models/ICompany";

const Container = styled.div`
  max-width: 98%;
  margin: 1em auto;
`;
export interface IIntegrationDetailWithDataProps extends RouteComponentProps<{ id: string }> {
  token: string;
  company?: ICompany;
}

const IntegrationDetailWithData = (props: IIntegrationDetailWithDataProps) => {
  const {
    token,
    company,
    match: {
      params: { id },
    },
  } = props;
  const idNum = parseInt(id, 10);

  const [isLoading, setIsLoading] = React.useState(true);
  const [quietReload, setQuietReload] = React.useState(false);
  const [stamp, setStamp] = React.useState(new Date());

  const [integration, setIntegration] = React.useState<IIntegration | undefined>();
  const [readOnly, setReadOnly] = React.useState<boolean>(true);

  React.useEffect(() => {
    const getIntegration = async () => {
      const integrationRepo = await new Services().IntegrationRepository();
      try {
        setIsLoading(true);
        if (idNum) {
          const resp = await integrationRepo.getById(token, idNum);
          setIntegration(resp);
        } else {
          throw new Error("ID is not valid");
        }
      } catch (err) {
        snackbarService.error(err);
      }

      setIsLoading(false);
      setQuietReload(false);
    };

    getIntegration();
  }, [id, stamp]);

  return (
    <IntegrationContextProvider companyId={company ? company.ID : 0} token={token} integrationId={idNum}>
      <Container>
        <WithLoadingSpinners message="Gathering data" isLoading={!quietReload && isLoading}>
          {integration && <IntegrationDetail model={integration} readonly={readOnly} />}
        </WithLoadingSpinners>
      </Container>
    </IntegrationContextProvider>
  );
};

export default connect((state: IApplicationState) => {
  return {
    ...selectAuth(state),
    company: selectCompany(state),
  };
})(IntegrationDetailWithData);
